import React from "react";
import { connect } from "react-redux";
import objectPath from "object-path";
import Topbar from "./Topbar";
import KTHeader from "../../_assets/js/header";
import * as builder from "../../ducks/builder";
import Logo from "../../../app/asset/logo";
// import {makeStyles, withStyles} from "@material-ui/core/styles";
// import Slider from "@material-ui/core/Slider";

class Header extends React.Component {
  headerCommonRef = React.createRef();

  componentDidMount() {
    let options = {};
    if (
      this.headerCommonRef.current.getAttribute("data-ktheader-minimize") ===
      "1"
    ) {
      options["minimize.desktop.on"] = "kt-header--minimize";
      options["offset.desktop"] = 130;
    }

    // eslint-disable-next-line no-undef
    new KTHeader(this.headerCommonRef.current, options);
  }

  render() {
    const {
      // menuHeaderDisplay,
      headerAttributes,
      headerClasses
    } = this.props;

    // const IOSSlider4 = withStyles({
    //     headerLogo: {
    //       "@media (min-width: 1024)": {
    //         height: '100%'
    //       }
    //     }
    // })(Slider);

    //
    // Main component
    //
    return (
      <div // Needed
        className={`kt-header ${headerClasses}`}
        // className={`kt-header kt-grid__item ${headerClasses}`}
        id="kt_header"
        ref={this.headerCommonRef}
        {...headerAttributes}
        style={{
          background:'#2F4F83',
          height:'55px',
        }}
      >
        <div // Needed
          className={`${headerAttributes} container-fluid d-flex align-middle justify-content-between kt-header-logo`}
          style={window.innerWidth <= 1024 ? {height: '100%'} : {}}
        >
          {/* responsive 1024 height: 100%; */}
          <img src={Logo} alt="logo" ></img>
          {/*begin::Topbar*/}
          <Topbar />
          {/*end::Topbar*/}
        </div>
        {/* <AnimateLoading /> */}
        {/* <!-- begin: Header Menu --> */}
        {/* {menuHeaderDisplay && <HMenu />} */}
        {/* <!-- end: Header Menu --> */}
        {/* <!-- begin:: Header Topbar --> */}
        {/* <!-- empty div to fix topbar to stay on the right when menu-horizontal is hidden --> */}
        {/* {!menuHeaderDisplay && <div />} */}
        {/* <Topbar /> */}
        {/* <!-- end:: Header Topbar --> */}
      </div>
    );
  }
}
/**
 * 
 * 
 */
const mapStateToProps = store => ({
  headerClasses: builder.selectors.getClasses(store, {
    path: "header",
    toString: true
  }),
  headerAttributes: builder.selectors.getAttributes(store, { path: "header" }),
  menuHeaderDisplay: objectPath.get(
    store.builder.layoutConfig,
    "header.menu.self.display"
  ),
  fluid:
    objectPath.get(store.builder.layoutConfig, "header.self.width") === "fluid"
});

export default connect(mapStateToProps)(Header);
